"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../hooks");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
const useStyles = (width, stokeWidth, unit) => {
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccDonutStyle = (0, _react.useMemo)(() => {
    const ccDonut = (0, _css.css)({
      position: 'relative',
      top: 0,
      left: 0,
      width: pxToRem(width),
      height: pxToRem(width)
    });
    const ccDonutBasicCircle = () => {
      return {
        cx: width / 2,
        cy: width / 2,
        strokeWidth: stokeWidth,
        fill: 'none'
      };
    };
    const ccDonutBackgroundCircle = (0, _css.css)({
      ...ccDonutBasicCircle(),
      stroke: themeColors?.basic.light
    });
    const ccDonutValueCircle = (0, _css.css)({
      ...ccDonutBasicCircle(),
      stroke: themeColors?.primary.main,
      transform: `rotate(-90deg)`,
      transformOrigin: 'center'
    });
    const ccDonutText = (0, _css.css)({
      position: 'absolute',
      width: '100%',
      top: '50%',
      transform: 'translate(0, -50%)',
      textAlign: 'center',
      fontFamily,
      color: themeColors?.primary.main,
      left: unit && unit.length > 0 ? pxToRem(unit.length * 2) : 0
    });
    const ccDonutValue = (0, _css.css)({
      fontSize: pxToRem(Math.floor(width / 3))
    });
    const ccDonutUnit = (0, _css.css)({
      fontSize: pxToRem(Math.floor(width / 5.5))
    });
    return {
      ccDonut,
      ccDonutBackgroundCircle,
      ccDonutValueCircle,
      ccDonutText,
      ccDonutValue,
      ccDonutUnit
    };
  }, [width, stokeWidth, unit, fontFamily, themeColors?.basic.light, themeColors?.primary.main, pxToRem]);
  return {
    'cc-Donut': ccDonutStyle.ccDonut,
    'cc-Donut__background-circle': ccDonutStyle.ccDonutBackgroundCircle,
    'cc-Donut__value-circle': ccDonutStyle.ccDonutValueCircle,
    'cc-Donut__text': ccDonutStyle.ccDonutText,
    'cc-Donut__text__value': ccDonutStyle.ccDonutValue,
    'cc-Donut__text__unit': ccDonutStyle.ccDonutUnit
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;